








import { Component, Prop, Vue } from 'vue-property-decorator';
import UserName from '@/components/global/UserName.vue';
import BackButton from '@/components/room/status/chatList/chat/chatHeader/BackButton.vue';
import CallButton from '@/components/room/status/chatList/chat/chatHeader/CallButton.vue';
import { groupChatId } from '@/utils/constants';
import { store } from '@/utils/store';

@Component({
  components: {
    UserName,
    BackButton,
    CallButton,
  },
})
export default class ChatHeader extends Vue {
  @Prop({ required: true }) id!: string;

  get talking() {
    return store.callStatus === 'calling';
  }
  get isGroup() {
    return this.id.startsWith(groupChatId);
  }
  get chatName() {
    return (this.isGroup)
      ? 'Group chat'
      : this.id;
  }
}
